import { FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";

// Grid/table-only field (not part of the equipment form).
export const positioning: FieldSchema = {
  name: "positioning",
  // Read-only / additional-info field: fetched & displayed, but excluded from
  // create/update mutations (managed outside the schema equipment form).
  dataTransform: { toGraphql: undefined },
  grid: {
    displayed: true,
    order: 63,
    label: "Positioning",
    filter: GridFilterTypes.TEXT,
    sortable: false,
    ignoredForSearch: true,
  },
};
